import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { ArchivedFile } from 'src/models/archived-file';
import {
  FormContext,
  FormCustomField,
  FormLocalDateField,
  FormPanel,
  FormTextArea,
  FormTextField,
  TextField,
} from '@eas/common-web';
import { OpenImage } from '@components/open-image/open-image';
import { ZsdUser } from '@models';

export function formatUserName(user: ZsdUser | undefined | null) {
  if (!user) return '-';
  return `${user.lastName ?? ''} ${user.firstName ?? ''}`;
}

function DefectUpdateDialog() {
  const { getFieldValues } = useContext(FormContext);
  const imagesBefore = (getFieldValues().imagesBefore ?? []) as ArchivedFile[];
  const imagesAfter = (getFieldValues().imagesAfter ?? []) as ArchivedFile[];

  return (
    <>
      <FormPanel
        defaultExpanded={true}
        label={
          <FormattedMessage
            id="ZSD__ABSENCE__DETAIL__FIELD_LABEL__DETAILS"
            defaultMessage="Detail"
          />
        }
      >
        <FormTextField
          disabled
          name="type.category.name"
          label={
            <FormattedMessage
              id="ZSD__DEFECT__DETAIL__FIELD_LABEL__CATEGORY_NAME"
              defaultMessage="Kontrolný bod"
            />
          }
        />
        <FormTextField
          disabled
          name="type.name"
          label={
            <FormattedMessage
              id="ZSD__DEFECT__DETAIL__FIELD_LABEL__TYPE_NAME"
              defaultMessage="Nedostatok"
            />
          }
        />
        <FormTextField
          disabled
          name="type.severity"
          label={
            <FormattedMessage
              id="ZSD__DEFECT__DETAIL__FIELD_LABEL__SEVERITY"
              defaultMessage="Závažnosť"
            />
          }
        />
        <FormLocalDateField
          name="discoveryDate"
          disabled
          label={
            <FormattedMessage
              id="ZSD__DEFECT__DETAIL__FIELD_LABEL__DISCOVERY_DATE"
              defaultMessage="Dátum zadania"
            />
          }
        />
        <FormCustomField name="discoveredBy" label="Kto zadal" disabled>
          <TextField
            value={formatUserName(getFieldValues().discoveredBy)}
            disabled
          />
        </FormCustomField>

        <FormCustomField
          name="solved"
          label={
            <FormattedMessage
              id="ZSD__DEFECT__DETAIL__FIELD_LABEL__STATE"
              defaultMessage="Stav"
            />
          }
        >
          <TextField
            disabled
            value={getFieldValues().solved ? 'Vyriešený' : 'Nevyriešený'}
          />
        </FormCustomField>
      </FormPanel>
      <FormPanel
        defaultExpanded={true}
        label={
          <FormattedMessage
            id="ZSD__ABSENCE__DETAIL__FIELD_LABEL__ADDITIONAL_DETAILS"
            defaultMessage="Ďalšie údaje"
          />
        }
      >
        <FormTextField
          disabled
          name="defectId"
          label={
            <FormattedMessage
              id="ZSD__DEFECT__DETAIL__FIELD_LABEL__"
              defaultMessage="ID nedostatku"
            />
          }
        />
        <FormTextField
          disabled
          name="component.name"
          label={
            <FormattedMessage
              id="ZSD__DEFECT__DETAIL__FIELD_LABEL__"
              defaultMessage="Komponenta"
            />
          }
        />

        <FormTextArea
          disabled
          name="description"
          minRows={1}
          label={
            <FormattedMessage
              id="ZSD__DEFECT__DETAIL__FIELD_LABEL__"
              defaultMessage="Popis"
            />
          }
        />

        <FormTextField
          disabled
          name="amount"
          label={
            <FormattedMessage
              id="ZSD__DEFECT__DETAIL__FIELD_LABEL__"
              defaultMessage="Množstvo"
            />
          }
        />

        <FormTextField
          disabled
          name="threatLevel"
          label={
            <FormattedMessage
              id="ZSD__DEFECT__DETAIL__FIELD_LABEL__"
              defaultMessage="Miera nebezpečenstva"
            />
          }
        />

        <FormCustomField name="resolvedBy" label="Vyriešil" disabled>
          <TextField
            value={formatUserName(getFieldValues().resolvedBy)}
            disabled
          />
        </FormCustomField>

        <FormLocalDateField
          name="resolutionDate"
          disabled
          label={
            <FormattedMessage
              id="ZSD__DEFECT__DETAIL__FIELD_LABEL__"
              defaultMessage="Dátum vyriešenia"
            />
          }
        />

        <FormTextArea
          disabled
          name="solutionComment"
          minRows={1}
          label={
            <FormattedMessage
              id="ZSD__DEFECT__DETAIL__FIELD_LABEL__"
              defaultMessage="Poznámka k vyriešeniu"
            />
          }
        />

        <FormTextArea
          disabled
          minRows={1}
          name="solutionMethod"
          label={
            <FormattedMessage
              id="ZSD__DEFECT__DETAIL__FIELD_LABEL__"
              defaultMessage="Metóda riešenia"
            />
          }
        />

        <FormCustomField
          name="imagesBefore"
          label={
            <FormattedMessage
              id="ZSD__DEFECT__DETAIL__FIELD_LABEL__"
              defaultMessage="Fotografie pred"
            />
          }
          disabled
        >
          {imagesBefore.map((archivedFile) => (
            <OpenImage
              archivedFile={archivedFile}
              key={archivedFile.file?.id}
            />
          ))}
        </FormCustomField>
        <FormCustomField
          name="imagesAfter"
          label={
            <FormattedMessage
              id="ZSD__DEFECT__DETAIL__FIELD_LABEL__"
              defaultMessage="Fotografie po"
            />
          }
          disabled
        >
          {imagesAfter.map((archivedFile) => (
            <OpenImage
              archivedFile={archivedFile}
              key={archivedFile.file?.id}
            />
          ))}
        </FormCustomField>
      </FormPanel>
    </>
  );
}

export default DefectUpdateDialog;
